<template>
  <div class="toolbar">
    <div style="width: 319px;display: flex;align-items: center">
      <div class="name" style="min-width: 60px">
        名称：
      </div>
      <div  v-show="nameFlag" class="name">
        {{this.esp(form.sceneName)}}
      </div>
      <el-input v-show="!nameFlag" id="name" v-model="form.sceneName" maxlength="20" style="width: 196px;font-weight: 400;color: #4D78FF;font-size: 18px;margin-right: 5px;" size="small" clearable></el-input>
      <div v-show="nameFlag" style="font-size: 20px;">
        <i class="el-icon-edit" style="cursor: pointer;color: #4D78FF" @click="nameFlag = !nameFlag"></i>
      </div>
      <el-button v-show="!nameFlag" style="background:#4D78FF;color: white;border-color: #4D78FF;border-radius: 4px" size="small " @click="consoleData">保存</el-button>
    </div>

    <div style="width:30%;text-align: center">
      <el-input
          v-model="keyword"
          size="small"
          placeholder="搜索原子服务"
          style="width: 268px;">
        <i slot="prefix" class="el-input__icon el-icon-search" style="color:#4D78FF;"></i>
      </el-input>
    </div>
    <div style="margin-right: 2%;cursor: pointer;margin-left: 8%;display: flex;">
      <i class="el-icon-question" style="margin: auto;color: #4D78FF;font-size: 24px;" @click="help"></i>
      <span style="margin: auto 20px auto auto;font-size: 16px; min-width: 35px;" @click="help">帮助</span>
      <i class="el-icon-s-tools" style="margin: auto;color: #4D78FF;font-size: 24px;" @click="open"></i>
      <span style="margin: auto 20px auto auto;font-size: 16px; min-width: 35px;" @click="open">设置</span>
    <!-- </div>

    <div style="margin-right: 2%;cursor: pointer;display: flex;" @click="run" > -->
      <img src="@/assets/img/editor/start.png" alt="" width="24" height="24" @click="run">
      <span style="margin: auto 20px auto auto;font-size: 16px; min-width: 35px;" @click="run">运行</span>
    <!-- </div>
    <div style="margin-right: 6%;cursor: pointer;display: flex;" @click="save"> -->
      <!-- <i class="el-icon-upload" style="margin: auto;color: #4D78FF;font-size: 26px;" @click="save(false)"></i>
      <span style="margin: auto 20px auto auto;font-size: 16px; min-width: 35px;" @click="save(false)">保存</span> -->
    </div>
<!--    <div style="margin-right: 40px;width:80px;display: flex;justify-content:space-around">-->
<!--      <div style="width: 30px">-->
<!--        <img v-show="undoList.length>0"  src="@/assets/img/editor/cancel.png" style="width: 30px;cursor: pointer" @click="handleUndo" alt="">-->
<!--      </div>-->
<!--      <div style="width: 30px">-->
<!--        <img v-show="redoList.length>0"  src="@/assets/img/editor/rollback.png" style="width: 30px;cursor: pointer" @click="handleRedo" alt="">-->
<!--      </div>-->
<!--    </div>-->
    <div style="width: 200px">
      <!-- <el-button
        style="border-radius: 20px;font-size: 14px;color: #4D78FF;border-color: #4D78FF;margin-right: 6px;width: 102px;box-sizing: border-box"
        size="small"
        @click="openWork"
        @mouseleave.native="btnFlag = !btnFlag"
        @mouseenter.native="btnFlag = !btnFlag">{{typeName}}</el-button> -->
      <el-button
        class="scene-save-btn"
        size="small"
        @click="save(false)">保存</el-button>
    </div>
    <div>
      <i class="el-icon-close" style="margin: auto;color: #999999;font-size: 26px;cursor: pointer;float: right" @click="leave"></i>
    </div>
    <el-dialog
        :visible.sync="publishingSettings"
        :modal-append-to-body="false"
        :append-to-body="true"
        width="50%"
        center>
      <div style="padding: 0 22%">
        <el-form :model="form" label-width="">
          <el-row style="text-align: center;display: flex;">
            <div style="display: flex;font-size: 14px;color: black;padding-bottom: 20px">
              场景名称：
            </div>
            <span style="padding-left: 10px">
            {{this.esp(form.sceneName)}}
              </span>
          </el-row>
          <div style="display: flex;font-size: 14px;color: black">场景介绍:
            <el-input
                v-model="form.sceneDesc"
                resize="none"
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                style="width: 80%;margin-left: 4%">
            </el-input>
          </div>
          <el-row>
            <el-col style="text-align: center;display: flex;padding-top: 20px">
              <el-form-item label="场景图标：" style="display: inline-flex;white-space:nowrap;">
                <div style="display:flex">
                  <el-upload
                      :limit="1"
                      :before-upload="beforeUpload"
                      list-type="picture-card"
                      action=""
                      :http-request="cutomUpload"
                      :file-list="fileList"
                      :on-exceed="handleExceed"
                  >
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                      <img class="el-upload-list__item-thumbnail" :src="form.logoUrl">
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                  <el-dialog :visible.sync="uploadDialogVisible">
                    <img width="100%" :src="dialogImageUrl">
                  </el-dialog>
                </div>
                <div style="font-size: 12px;text-align: left;line-height: 20px;">
                <span>图片格式：png、jpg、jpeg，且不超过500kb，</span><br>
                <span>最多上传一张图片,建议尺寸：230 X 150 px</span>
              </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="场景分类：" style="display: inline-flex;">
                <el-select v-model="form.sceneType" clearable placeholder="未分类" style="width: 246px">
                  <el-option
                      v-for="item in options"
                      :key="item.tagId"
                      :label="item.tagName"
                      :value="item.tagName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small " type="primary" style="background-color: #4D78FF;border-radius: 20px;padding: 8px 25px" @click="saveAttr">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="设置"
        :visible.sync="centerDialogVisible"
        :modal-append-to-body="false"
        :append-to-body="true"
        width="50%"
        center>
      <div style="padding: 0 22%">
        <el-form :model="form" label-width="">
        <div style="display: flex;font-size: 14px;color: black">场景介绍:
          <el-input
              v-model="form.sceneDesc"
              resize="none"
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              style="width: 80%;margin-left: 4%"
              maxlength="1000">
          </el-input>
        </div>
        <el-row>
          <el-col style="text-align: center;display: flex;padding-top: 20px">
            <el-form-item label="场景图标：" style="display: inline-flex;white-space:nowrap;">
              <div style="display:flex">
                <el-upload
                    :limit="1"
                    :before-upload="beforeUpload"
                    list-type="picture-card"
                    action=""
                    :http-request="cutomUpload"
                    :file-list="fileList"
                    :on-exceed="handleExceed"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="form.logoUrl">
                    <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="uploadDialogVisible">
                  <img width="100%" :src="dialogImageUrl">
                </el-dialog>
              </div>
              <div style="font-size: 12px;text-align: left;line-height: 20px;">
                <span>图片格式：png、jpg、jpeg，且不超过500kb，</span><br>
                <span>最多上传一张图片,建议尺寸：230 X 150 px</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row>
            <el-col>
              <el-form-item label="场景分类：" style="display: inline-flex;">
                <el-select v-model="form.sceneType" clearable placeholder="未分类" style="width: 246px">
                  <el-option
                      v-for="item in options"
                      :key="item.tagId"
                      :label="item.tagName"
                      :value="item.tagName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small " type="primary" style="background-color: #4D78FF;border-radius: 20px;padding: 8px 25px" @click="saveAttr">确 定</el-button>
        <el-button size="small " style="background-color: #fff;border-radius: 20px;padding: 8px 25px" @click="centerDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-drawer
        title=""
        size="80%"
        :visible.sync="drawer"
        :with-header="false">
      <div style="width: 100%; height: 100%;">
        <div style="text-align: center; font-size: 18px; font-weight: bold; margin: 0px 0px 40px 0px;">场景状态</div>
        <div style="width: 100%; height: 120px;">
          <el-col :span="8" style="text-align: center;">
            <img :src="img1" alt="" style="width: 117px; height: 127px;">
          </el-col>
          <el-col :span="8" style="text-align: center;">
            <img :src="img2" alt="" style="width: 117px; height: 127px;">
          </el-col>
          <el-col :span="8" style="text-align: center;">
            <img :src="img3" alt="" style="width: 117px; height: 127px;">
          </el-col>
        </div>
        <div style="width: 100%; height: 40px;margin: 20px 0px 10px 0px;">
          <el-col :span="8" :offset="4" style="height: 100%;display: flex;align-items: center;">
            <div :class="sceneStatus.sceneStatus > 0 ? 'onOver' : 'onWork'" style="border-radius: 50%; width: 20px; height: 20px; margin-left: -14px;"></div>
            <div :class="sceneStatus.sceneStatus > 0 ? 'onWork_line' : 'line'" style="width: calc(100% - 34px)"></div>
          </el-col>
          <el-col :span="8" style="height: 100%;display: flex;align-items: center;">
            <div :class="[sceneStatus.sceneStatus < 1 ? 'onInit' : '', sceneStatus.sceneStatus > 1 ? 'onOver' : '', sceneStatus.sceneStatus == 1 ? 'onWork' : '']"  style="border-radius: 50%;width: 20px;height: 20px; margin-left: -14px;"></div>
            <div :class="sceneStatus.sceneStatus > 1 ? 'onWork_line' : 'line'" style="width: calc(100% - 34px)"></div>
          </el-col>
          <el-col :span="4" style="height: 100%;display: flex;align-items: center;">
            <div :class="[sceneStatus.sceneStatus < 2 ? 'onInit' : '', sceneStatus.sceneStatus > 2 ? 'onOver' : '', sceneStatus.sceneStatus == 2 ? 'onWork' : '']" style="border-radius: 50%;width: 20px;height: 20px; margin-left: -14px;"></div>
          </el-col>
        </div>
        <div style="height: 30px;width: 100%;font-size: 12px;text-align: center;">
          <el-col :span="8" style="height: 100%; text-align: center;">
            <div v-if="sceneStatus.sceneStatus === 0" class="status">开发中</div>
            <div v-if="sceneStatus.sceneStatus > 0" class="status">开发完成</div>
          </el-col>
          <el-col :span="8" style="height: 100%; text-align: center;">
            <div v-if="sceneStatus.sceneStatus < 1" class="waitStatus">等待中</div>
            <div v-if="sceneStatus.stageStatus === 10" class="status">等待测试</div>
            <div v-if="sceneStatus.stageStatus === 11" class="status">测试中</div>
            <div v-if="sceneStatus.stageStatus >= 12" class="status">测试完成</div>
          </el-col>
          <el-col :span="8" style="height: 100%; text-align: center;">
            <div v-if="sceneStatus.sceneStatus < 2" class="waitStatus">等待中</div>
            <div v-if="sceneStatus.stageStatus === 20" class="status">等待发布</div>
            <div v-if="sceneStatus.stageStatus <= 22 && sceneStatus.stageStatus > 20" class="status">发布完成</div>
          </el-col>
        </div>
        <div style="height: 340px; margin: 20px 0px;">
          <div style="width: 100%; height: 100%; display: flex; overflow: auto;">
            <el-col v-if="testInfo&&testInfo.vehicle" :span="8" :offset="8">
              <div v-for="(item, index) in testInfo.vehicle.node" :key="'vehicle' + index" style="margin-left: 40%;font-size: 14px;margin-bottom: 15px;">
                <div style="">
                  <i class="el-icon-time" style="font-size: 20px;"></i>
                  {{item.message}}
                  <span v-if=" index === 2 && (sceneStatus.stageStatus === 12 || sceneStatus.stageStatus >= 20)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #09D589;border-radius: 13px;color: #09D589;text-align: center;letter-spacing:1px;padding:0 5px">通过</span>
                  <span v-if=" index === 2 && (sceneStatus.stageStatus === 13)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #FF0000;border-radius: 13px;color: #FF0000;text-align: center;letter-spacing:1px;padding:0 5px">不通过</span>
                </div>
                <div style="font-size: 12px;color: #999999;padding-top: 10px;padding-bottom: 11px">{{item.time}}</div>
                <div v-if="item.memo" style="font-size: 12px;color: #999999;"><el-button type="text" @click="showRefuseMessage(item.memo)">不通过原因</el-button></div>
              </div>
              <div v-if="testInfo.vehicle.url" style="margin-left: 18%;font-size: 14px;">
                <a :href="testInfo.vehicle.url" style="color: #4D78FF">查看报告></a>
              </div>
            </el-col>
            <el-col v-if="testInfo&&testInfo.release" :span="8">
              <div v-for="(item, index) in testInfo.release.node" :key="'release' + index" style="margin-left: 40%;font-size: 14px;margin-bottom: 15px;">
                <div style="">
                  <i class="el-icon-time" style="font-size: 20px;"></i>
                  {{item.message}}
                  <span v-if=" index === 1 && (sceneStatus.stageStatus === 21)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #09D589;border-radius: 13px;color: #09D589;text-align: center;letter-spacing:1px;padding:0 5px">通过</span>
                  <span v-if=" index === 1 && (sceneStatus.stageStatus === 22)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #FF0000;border-radius: 13px;color: #FF0000;text-align: center;letter-spacing:1px;padding:0 5px">不通过</span>
                </div>
                <div style="font-size: 12px;color: #999999;padding-top: 10px;padding-bottom: 11px">{{item.time}}</div>
                <div v-if="item.memo" style="font-size: 12px;color: #999999;"><el-button type="text" @click="showRefuseMessage(item.memo)">不通过原因</el-button></div>
              </div>
              <div v-if="testInfo.release.url" style="margin-left: 18%;font-size: 14px;">
                <a :href="testInfo.release.url" style="color: #4D78FF">查看报告></a>
              </div>
            </el-col>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content:center" >
          <el-button v-if="sceneStatus.stageStatus === 10" size="medium" round style="background-color:#FF0000;border-color: #FF0000;color: white;" @click="testScene" >取消</el-button>
          <el-button v-if="sceneStatus.stageStatus === 0 || sceneStatus.stageStatus === 1" size="medium" round style="background-color:#4D78FF;border-color: #4D78FF;color: white" @click="testScene" >提交车辆测试</el-button>
          <el-button v-if="sceneStatus.stageStatus === 12" size="medium" round style="background-color:#4D78FF;border-color: #4D78FF;color: white;" @click="Submit" >提交发布</el-button>
          <el-button v-if="(sceneStatus.stageStatus === 13 || sceneStatus.stageStatus === 22)" size="medium" round style="background-color:#FF0000;border-color: #FF0000;color: white;" @click="backDevelop" >重新开发</el-button>
          <el-button v-if="sceneStatus.stageStatus === 20" size="medium" round style="background-color:#FF0000;border-color: #FF0000;color: white;" @click="releaseScene" >取消</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import car_done from '@/assets/img/editor/done/car_done.png'
import release_done from '@/assets/img/editor/done/release_done.png'
import work_done from '@/assets/img/editor/done/work_done.png'
import car_wait from '@/assets/img/editor/wait/car_wait.png'
import release_wait from '@/assets/img/editor/wait/release_wait.png'
import car_work from '@/assets/img/editor/work/car_work.png'
import work_work from '@/assets/img/editor/work/work_work.png'
import { testScene, getTestSceneInfo, getSceneTotal, addOrUpdateScene, selectScene, makeOperationStr, releaseScene } from '@/api/modules/beginner'
import { getUploadKey } from '@/api/modules/api'
import { getLabel } from '@/api/modules/forum'
import COS from 'cos-js-sdk-v5'
export default {
  data() {
    return {
      options: [],
      usersCurrentInfo: {},
      sceneStatus: {},
      page: {},
      graph: {},
      editor: null,
      command: null,
      selectedItem: null,
      multiSelect: false,
      addGroup: false,
      sceneId: this.$route.query.id,
      textarea: '',
      centerDialogVisible: false,
      dialogVisible: false,
      fileList: [],
      dialogImageUrl: '',
      uploadDialogVisible: false,
      keyword: '',
      workType: 1,
      testFlag: false,
      nameFlag: true,
      btnFlag: false,
      drawer: false,
      disabled: false,
      // form: { sceneStatus: 1 },
      form: {
        id: null,
        catalogueId: this.$route.query.catalogueId,
        sceneName: '',
        sceneDesc: '',
        logoUrl: '',
        logoKey: '',
        sceneStatus: 0,
        nodeDetailParams: '{"nodes":[{"id":"node_1","type":"start-node","x":650,"y":100,"text":"开始"}]}'
      },
      testInfo: {},
      lf: null,
      autoSaveTimer: null,
      host: location.hostname === 'localhost' ? 'https://usp-test.uaes.com' : ''
    }
  },
  computed: {
    typeName() {
      if (this.btnFlag) {
        return '变更'
      }
      if (this.form.sceneStatus === 1) {
        return '车辆测试'
      }
      if (this.form.sceneStatus === 2) {
        return '发布'
      }
      else {
        return '测试与发布'
      }
    },
    img1() {
      if (this.form && Number(this.sceneStatus.sceneStatus) === 0) {
        return work_work
      }
      return work_done
    },
    img2() {
      if (this.form && Number(this.sceneStatus.sceneStatus) === 1) {
        return car_work
      }
      if (this.form && Number(this.sceneStatus.sceneStatus) > 1) {
        return car_done
      }
      return car_wait
    },
    img3() {
      if (this.form && Number(this.sceneStatus.sceneStatus) === 2) {
        return release_done
      }
      return release_wait
    }
  },
  watch: {
    selectedItem(val) {
      if (val && val.length > 1) {
        this.addGroup = true
      }
      else {
        this.addGroup = false
      }
    },
    keyword(val) {
      eventBus.$emit('keyword', val)
    }
  },
  created() {
    this.getLabel()
    this.usersCurrentInfo = JSON.parse(localStorage.getItem('usersCurrentInfo'))
    // this.init()
    if (this.sceneId !== '' && this.sceneId !== null && this.sceneId !== undefined) {
      this.selectScene()
    }
    else {
      this.getSceneTotal()
    }
    eventBus.$on('loadNodeReturn', (lf) => {
      // console.log(JSON.parse(param), 666)
      this.lf = lf
    })
  },
  methods: {
    async getLabel() {
      const data = {
        status: 1,
        tagGroupId: '1040925626048364544',
        pageSize: 1000
      }
      const res = await getLabel(data)
      if (res.code === 0) {
        this.options = res.data.dataList
      }
    },
    async selectScene() {
      const data = { id: this.sceneId }
      const res = await selectScene(data)
      this.form = res.data
      if (res.data.logoUrl !== '' && res.data.logoUrl !== null) {
        this.fileList = [{ name: res.data.logoUrl, url: res.data.logoUrl }]
      }
      this.$nextTick(() => {
        eventBus.$emit('loadNode', this.form.nodeDetailParams)
      })
      this.$emit('sendSceneStatus', this.form.sceneStatus)
      console.log('res', res)
    },
    beforeUpload(file) {
      this.addResource = file
      this.fileName = file.name
      console.log(file)
      if (this.addResource.type === 'image/png' || this.addResource.type === 'image/jpg' || this.addResource.type === 'image/jpeg') {
        if (file.size < 500 * 1024) {
          this.fileList = []
          this.$message.success('正在上传')
          return true
        }
        else {
          this.$message.error('图片大小不能超过500kb')
          return false
        }
      }
      this.$message.error('文件格式有误')
      return false
    },
    async cutomUpload(data) {
      console.log(data)
      const { file } = data
      const res = await getUploadKey(0)
      const cosKey = res.data
      console.log(cosKey)
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      const key = 'web/img/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          console.log(JSON.stringify(progressData))
        }
      }, (err, data) => {
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.form.logoKey = key
        this.form.logoUrl = 'http://' + data.Location
        this.fileList = [{ name: file.name, url: 'http://' + data.Location }]
        console.log(this.list)
        console.log(err || data)
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个图片，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    handleRemove(file) {
      this.form.logoKey = ''
      this.form.logoUrl = ''
      this.fileList = []
      console.log(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.uploadDialogVisible = true
    },
    saveAttr() {
      const type = this.form.id ? '1' : '0'
      this.addOrUpdateScene(type, false)
      this.centerDialogVisible = false
    },
    async addOrUpdateScene(type, autoFlag) {
      this.form.nodeDetailParams = JSON.stringify(this.lf.getGraphData())
      const form = this.form
      form.uesType = type
      const res = await addOrUpdateScene(form)
      if (res.code === 0) {
        if (!autoFlag) {
          this.$message({
            message: '保存成功！',
            type: 'success'
          })
        }
        this.form.id = res.data.id
        this.form.sceneStatus = res.data.sceneStatus
        window.history.replaceState({ id: 1, name: 'beginner' }, 'USP开发者平台-产品原型设计', '/beginner/editor?id=' + res.data.id)

        // this.form = res.data
      }
      else {
        console.log(res.msg)
        this.nameFlag = !this.nameFlag
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async getSceneTotal() {
      const res = await getSceneTotal({})
      if (res.code === 0) {
        this.form.sceneName = '您的第' + res.data + '个场景'
        this.$nextTick(() => {
          eventBus.$emit('loadNode', this.form.nodeDetailParams)
        })
        this.$emit('sendSceneStatus', this.form.sceneStatus)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async run() {
      const makeData = this.lf.getGraphData()
      console.log(makeData)
      const res = await makeOperationStr(makeData)
      if (res.code === 0) {
        this.$emit('handleClick', res.data)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async getTestSceneInfo() {
      const data = { id: this.form.id }
      const res = await getTestSceneInfo(data)
      if (res.code === 0) {
        this.form.sceneStatus = res.data.scene.sceneStatus
        this.sceneStatus = res.data.scene
        this.testInfo = res.data.testInfo
      }
      console.log('getTestSceneInfo')
      console.log(res.data)
    },
    async testScene() {
      const data = {
        id: this.form.id
      }
      const res = await testScene(data)
      if (res.code === 0) {
        this.form.sceneStatus = res.data.sceneStatus
        if (this.form.sceneStatus === 0) {
          this.$emit('sendSceneStatus', 4)
        }
        else {
          this.$emit('sendSceneStatus', 3)
        }
        this.$message({
          message: '提交成功！',
          type: 'success'
        })
        this.drawer = false
      }
    },
    async Submit() {
      if (this.usersCurrentInfo.email === null || this.usersCurrentInfo.phone === null) {
        await this.$router.push({ path: '/article/account' })
      }
      this.$message.error('请完善个人用户信息')
    },
    async releaseScene() {
      const data = {
        id: this.form.id
      }
      const res = await releaseScene(data)
      if (res.code === 0) {
        this.form.sceneStatus = res.data.sceneStatus
        if (this.form.sceneStatus === 0) {
          this.$emit('sendSceneStatus', 4)
        }
        else {
          this.$emit('sendSceneStatus', 3)
        }
        this.$message({
          message: '提交成功！',
          type: 'success'
        })
        this.drawer = false
      }
    },
    handlePreview(file) {
      console.log(file)
    },
    // init() {
    //   const { editor, command } = this.$parent
    //   this.editor = editor
    //   this.command = command
    // },
    changeType(type) {
      if (this.workType > 1 && this.testFlag) {
        return
      }
      if (this.workType < 2 && type === 3) {
        return
      }
      if (type === 1) {
        this.testFlag = false
      }
      this.workType = type
    },
    consoleData() {
      this.nameFlag = !this.nameFlag
      console.log(this.form)
      const flag = this.form.id ? '1' : '0'
      this.addOrUpdateScene(flag, false)
    },
    open() {
      this.centerDialogVisible = true
    },
    openWork() {
      if (!this.form.id) {
        this.$message.error('请先保存数据')
        return
      }
      this.getTestSceneInfo()
      this.drawer = true
    },
    leave() {
      this.$confirm('退出前请确认已保存', '警告', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        clearInterval(this.autoSaveTimer)
        this.autoSaveTimer = null
        if (this.form.catalogueId) {
          this.$router.push({ path: '/article/directory', query: { id: this.form.catalogueId }})
        }
        else {
          this.$router.push({ path: '/article/Beginner' })
        }
        this.$message({
          type: 'success',
          message: '退出成功'
        })
      }).catch(() => {
      })
    },
    save(autoFlag) {
      const type = this.form.id ? '1' : '0'
      this.addOrUpdateScene(type, autoFlag)
    },
    // 设置定时保存 0：开；1：关
    setSaveTimer(val) {
      if (val === 0) {
        if (!this.autoSaveTimer) {
          this.autoSaveTimer = setInterval(() => {
            this.autoSave()
          }, 10000)
        }
        else {
          clearInterval(this.autoSaveTimer)
          this.autoSaveTimer = setInterval(() => {
            this.autoSave()
          }, 10000)
        }
      }
      else if (val === 1) {
        if (this.autoSaveTimer) {
          clearInterval(this.autoSaveTimer)
          this.autoSaveTimer = null
        }
      }
      else if (val === 4) {
        this.setSaveTimer(0)
      }
      else if (val === 3) {
        clearInterval(this.autoSaveTimer)
        this.autoSaveTimer = null
        this.$router.push({
          path: '/beginner/editor',
          query: { id: this.form.id }
        })
      }
    },
    autoSave() {
      this.save(true)
    },
    help() {
      window.open(`${this.host}/document/9aca75a4ca1a931fa3aa7433a53551d5`)
      // this.$router.push({ path: '/document/0' })
    },
    esp(str) {
      return str.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    }
  }
}
</script>

<style scoped>
.toolbar {
  background-color: #fff;
  display: flex;
  box-sizing: border-box;
  padding: 12px 10px 13px 20px;
  width: 100%;
  border-bottom: 1px solid #DDDDDD;
  height: 61px;
  z-index: 3;
  /*box-shadow: 0px 8px 12px 0px rgba(0, 52, 107, 0.04);*/
  position: absolute;
  align-items:center;
  justify-content:space-between;
}
.toolbar .command:nth-of-type(1) {
  margin-left: 24px;
}
.toolbar .command {
  font-size: 24px;
  /*box-sizing: border-box;*/
  width: 27px;
  height: 27px;
  /*margin: 0px 6px;*/
  /*border-radius: 2px;*/
  padding-left: 6px;
  /*display: inline-block;*/
  /*border: 1px solid rgba(2, 2, 2, 0);*/
}
.toolbar .command:hover {
  cursor: pointer;
  /*font-size: 28px;*/
  /*border: 1px solid #e9e9e9;*/
}
.toolbar .name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 18px;
  font-weight: 400;
  color: #2F374B;
  line-height: 46px;
  letter-spacing: 2px;
  box-sizing: border-box;
}
.toolbar .disable {
  color: rgba(0, 0, 0, 0.25);
}
.toolbar .name_input {

}
/deep/.el-input__inner {
  border-radius: 20px;
  border: 1px solid #4D78FF;
}
/deep/#name{
  border-radius: 4px !important;
}
/deep/.el-dialog__title{
  font-size: 14px;
  font-weight: bold;
}
/deep/.el-dialog__header{
  padding: 40px 20px 0;
}
/deep/.el-dialog__footer{
  padding: 50px 20px 40px;
}
.onWork_line{
  border:2px solid #4D78FF;
}
.line{
  border:2px solid #DDDDDD;
}
.onInit{
  border: 5px solid #B8C9FF;
}
.onOver{
  border: 5px solid #4D78FF;
}
.onWork{
  border: 5px solid #49A37D;
}
/*/deep/.el-input.is-disabled .el-input__inner{*/
/*  border: unset;*/
/*  color: #2F374B;*/
/*  background-color: unset;*/
/*  width: auto;*/
/*}*/
.waitStatus{
  background-color: #F5F6F8;
  border: 1px solid #DDDDDD;
  color:#A7A7A7;
  border-radius: 12.5px;
  padding: 4px 0;
  width: 100px;
  display: inline-block;
}
.status{
  background-color: #EDFFEE;
  border: 1px solid #09D589;
  color:#09D589;
  border-radius: 12.5px;
  padding: 4px 0;
  width: 100px;
  display: inline-block;
}
.scene-save-btn {
  border-radius: 20px;
  font-size: 14px;
  color: rgb(255, 255, 255);
  background-color: #4D78FF;
  border-color: rgb(77, 120, 255);
  width: 72px;
  box-sizing: border-box
}
.scene-save-btn:hover {
  background-color: #355cd8;
}
::v-deep .el-drawer__body{
  overflow-y: auto;
}
</style>
